import type { GetterTree } from "vuex";
import type { SpacePresenceState } from "./state";
import type { SpaceMember } from "@ably/spaces";
import type { PresenceData } from "@/models";
import { UserRole } from "@/models";
import { defineVuexName, MODULES } from "../utils";

const getProfileData = (member: SpaceMember): PresenceData | undefined => {
  const profile = member.profileData as unknown as PresenceData | undefined;
  if (!member.isConnected) return undefined;
  if (!profile?.userId) return undefined;
  return profile;
};

const getters: GetterTree<SpacePresenceState, any> = {
  [defineVuexName(MODULES.SPACE_PRESENCE.GETTERS.GET_INSTANCE)]: (state) => state.instance,
  [defineVuexName(MODULES.SPACE_PRESENCE.GETTERS.GET_MEMBERS)]: (state) => Object.values(state.members),
  [defineVuexName(MODULES.SPACE_PRESENCE.GETTERS.GET_IS_INITIALIZED)]: (state) => !!state.instance,
  [defineVuexName(MODULES.SPACE_PRESENCE.GETTERS.GET_CHANNEL_NAME)]: (state) => state.spaceChannelName,
  [defineVuexName(MODULES.SPACE_PRESENCE.GETTERS.GET_PROFILE_DATA)]: (state) => state.profileData,
  [defineVuexName(MODULES.SPACE_PRESENCE.GETTERS.GET_ONLINE_STATUS_BY_IDS)]: (state) => (userIds: string[]) => {
    const online: string[] = [];
    const offline: string[] = [];
    const presentIds = new Set(
      Object.values(state.members)
        .map((member) => getProfileData(member)?.userId)
        .filter((id): id is string => !!id),
    );

    userIds.forEach((id) => {
      if (presentIds.has(id)) {
        online.push(id);
      } else {
        offline.push(id);
      }
    });

    return { online, offline };
  },

  [defineVuexName(MODULES.SPACE_PRESENCE.GETTERS.GET_STUDENT_USER_IDS)]: (state) => {
    const students = new Set<string>();
    Object.values(state.members).forEach((member) => {
      const profile = getProfileData(member);
      if (profile?.role === UserRole.STUDENT) {
        students.add(profile.userId);
      }
    });
    return students;
  },
};

export default getters;
